import { Box, Paper, styled, Typography } from '@mui/material';

import { Colors } from '../../../../utils/Colors';

export const StyledPaper = styled(Paper)({
    backgroundColor: Colors.black2,
    borderRadius: 2,
    padding: 24
});

export const Title = styled(Typography)({
    color: Colors.white90,
    font: '600 14px Inter',
    marginBottom: 16
});

// Mirrors `dashboards/src/shared/ExpandablePlan` — when `collapsed`, the
// container clamps to 320px and fades to transparent at the bottom so the
// user can tell there's more content behind the toggle.
export const PlanContainer = styled(Box, {
    shouldForwardProp: (prop) => prop !== 'collapsed'
})<{ collapsed?: boolean }>(({ collapsed }) => ({
    position: 'relative',
    color: Colors.white90,
    ...(collapsed && {
        maxHeight: 320,
        overflow: 'hidden',
        maskImage: 'linear-gradient(to bottom, black 60%, transparent 100%)',
        WebkitMaskImage:
            'linear-gradient(to bottom, black 60%, transparent 100%)'
    })
}));

export const PlanExpandToggle = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '8px 0 0',
    cursor: 'pointer',
    color: Colors.lightningYellow,
    fontFamily: '"Inter", sans-serif',
    fontSize: 13,
    fontWeight: 500,
    gap: 4,
    '&:hover': {
        opacity: 0.8
    }
});
